import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-candidate-conference-page',
  templateUrl: './candidate-conference-page.component.html',
  styleUrls: ['./candidate-conference-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CandidateConferencePageComponent implements OnInit {
  @Input() $transition$: any;

  stateParams: any;
  candidateId: any;
  jobId: any;
  jobMatchId: any;
  scheduleId: any;
  participantType: any;
  mode: any;
  workflowStep: any;
  isLoading: boolean;
  isLoaded: boolean;

  ngOnInit() {
    this.stateParams = this.$transition$.params();
    this.candidateId = this.stateParams.c;
    this.jobId = this.stateParams.j;
    this.jobMatchId = this.stateParams.jm;
    this.scheduleId = this.stateParams.sh;
    this.participantType = "c";
    this.mode = this.stateParams.mode;
    this.workflowStep = this.stateParams.ws;
    this.isLoaded = false;
  }

  onLoaded() {
    this.isLoaded = true;
  }
}
